var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReportProblem(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_214_1992)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.18515 24.5H24.8035C25.7018 24.5 26.2618 23.5317 25.8185 22.75L15.0035 4.08332C14.5485 3.30165 13.4285 3.30165 12.9852 4.08332L2.17015 22.75C1.72682 23.5317 2.28682 24.5 3.18515 24.5ZM15.1668 21H12.8335V18.6667H15.1668V21ZM14.0002 16.3333C13.3585 16.3333 12.8335 15.8083 12.8335 15.1667V12.8333C12.8335 12.1917 13.3585 11.6667 14.0002 11.6667C14.6418 11.6667 15.1668 12.1917 15.1668 12.8333V15.1667C15.1668 15.8083 14.6418 16.3333 14.0002 16.3333Z",
    fill: "#0E0E0E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_214_1992"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportProblem);
export default __webpack_public_path__ + "static/media/reportProblem.affc5462850309d696bbde60a36ae3f0.svg";
export { ForwardRef as ReactComponent };